import * as React from "react";
import styled, { css } from "styled-components";
import { Row } from "security-app/components/common/FormBaseStyles";
const NavTab = styled.span(
  ({ $active, theme }) => css`
    cursor: pointer;
    color: ${$active ? `${theme.colors.text.primary}` : "grey"};
    padding: 0.5rem;
    border-bottom: 1px solid ${$active ? `${theme.colors.button.primary.background}` : "transparent"};

    &:hover {
      color: ${theme.colors.text.primary};
    }
  `
);
function SmallNavTabs({ tabs, activeTab, onClick }) {
  return /* @__PURE__ */ React.createElement(Row, null, tabs.map((tab) => /* @__PURE__ */ React.createElement(
    NavTab,
    {
      key: tab.id,
      $active: activeTab === tab.id,
      onClick: () => onClick(tab.id),
      role: "tab",
      "aria-label": tab.id
    },
    /* @__PURE__ */ React.createElement(tab.Label, null)
  )));
}
export default SmallNavTabs;
